/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import useContextState from './useContextState';
import isString from 'lib/t/isString';
import isEmbedded from 'lib/isEmbedded';
import isPath from 'lib/isPath';
import { css, jsx } from '@emotion/core';
import { inputsColor } from './colors';

function LTFiltersBodyCheckbox({ value, toggle, label, name }) {
  const id = `filter-type-${name}`;
  return (
    <label className={name} htmlFor={id}>
      <input
        id={id}
        name="filter[type][]"
        value={name}
        checked={value.includes(name)}
        type="checkbox"
        className="filter-checkbox"
        onChange={() => toggle(name)}
      />{' '}
      {label}
    </label>
  );
}

export default function LTFiltersSectionTemplate(locals: {
  value: string[],
  onChange: (any) => void,
}): null | Element<string> {
  let value = locals.value || [];
  value = isString(value) ? [value] : value;
  const { filtersSectionsOriginal } = useContextState();

  function toggle(v) {
    const newValue = value.includes(v)
      ? value.filter((v3) => v3 !== v)
      : value.concat(v);
    locals.onChange(newValue);
  }

  const sectionFilter = (v) => {
    const os = filtersSectionsOriginal;
    if (!isEmbedded()) return true;
    if (os.length === 0) return true;
    return os.includes(v);
  };

  const sectionLabels = {
    Building: 'Buildings',
    Development: 'Development Activity',
    Listing: 'Real Estate Listings',
    StreetscapeAsset: 'Streetscape Assets',
    StreetscapeIssue: 'Streetscape Issues',
    Tenant: 'Businesses & Attractions',
    Unit: 'Units',
    Contact: 'Contacts',
    Event: 'Events',
    Property: 'Properties',
    Organization: 'Organizations',
  };

  const items = Object.keys(sectionLabels)
    .filter(sectionFilter)
    .map((k) => (
      <LTFiltersBodyCheckbox
        value={value}
        toggle={toggle}
        name={k}
        label={sectionLabels[k]}
        key={k}
      />
    ));

  if (items.length === 0) return null;
  if (!isPath('/map')) return null;

  return (
    <div
      id="page-filters-section"
      data-testid="LTFiltersSectionTemplate"
      className="pt-4 pl-4 pr-4 pb-3 border-bottom border-light-white"
      css={css(`
        label {
          display: block;
          font-weight: bold;
          font-size: 1em;
          line-height: 2em;
          cursor: pointer;
          color: ${inputsColor};
          text-transform: uppercase;
        }
        input[type='checkbox'] {
          margin-right: 10px;
        }
    `)}
    >
      {items}
    </div>
  );
}
